import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { SupportTickets } from "@/features/admin/components/support-tickets";
import { PageContainer } from "@/components/ui/page-container";

function AdminTicketsPage() {
  return (
    <PageContainer maxWidth="6xl">
      <SupportTickets />
    </PageContainer>
  );
}

export const adminTicketsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/tickets",
  component: AdminTicketsPage,
});
